import { IonCardContent, IonCard, IonSpinner, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component, useState, useEffect }  from 'react';

// import Swiper core and required modules
import SwiperCore, { Virtual, Zoom, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/zoom";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import ActionComp from '../components/ActionComp'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

export interface ReelData {
    avatar : string,
    thumbnail : string,
    path : string
};
  
const ReelContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const [reels, setReels] = useState<ReelData[]>([]);

    const router = useIonRouter();

    // build the reel list
    useEffect(() => {
        let r : ReelData[] = [];
        for (let i = 0; i < content.images.length; i++)
        {
            r.push({ "thumbnail": content.images[i], "avatar": content.supporters[i], "path": content.react_comments[i] });
        }
        setReels(r);
    },[content]);

    // select the reel
    const selectReel = (m : ReelData) => {
        router.push(m.path, "forward", "push");
    }

    return (
        <IonCard className="flat-card reel-content ion-no-margin">
            <div className="reel-title">
                { content.title }
            </div>
            <Swiper
                    className="reel-wrapper"
                    slidesPerView={2.5}
                    spaceBetween={0}
                    breakpoints={{
                        340: {
                            slidesPerView: 3.3,
                            spaceBetween: 0,
                        },
                        425: {
                            slidesPerView: 3.5,
                            spaceBetween: 0,
                        },
                        470: {
                            slidesPerView: 4.2,
                            spaceBetween: 0,
                        },
                        600: {
                            slidesPerView: 5.2,
                            spaceBetween: 0,
                        }
                    }}
                    virtual
                >
            {
                reels.map((m, index) => (
                    <SwiperSlide key={index} virtualIndex={index}>
                        <div className="reel-container ion-activatable ripple-parent" onClick={()=> selectReel(m)}>
                            <img className="reel-thumb"
                                src={ m.thumbnail } 
                                onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/content_avt.jpg' } }/>
                            <IonAvatar className="reel-avatar">
                                <img src={ m.avatar } onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                            </IonAvatar>
                            <IonRippleEffect></IonRippleEffect>
                        </div>
                    </SwiperSlide>
                ) )
            }
            </Swiper>
        </IonCard>
    );
};
  
export default ReelContent;